import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import MovdAuthCard from '../design-system/MovdAuthCard.jsx';
import MovdNotice from '../design-system/MovdNotice.jsx';
import MovdInput from '../design-system/MovdInput.jsx';
import MovdButton from '../design-system/MovdButton.jsx';

export default function AccountSetupPage() {
  const search = new URLSearchParams(useLocation().search);
  const token = search.get('token') || '';
  const returnTo = search.get('returnTo') || '/customer-portal';
  const requiresMoverAcceptance = search.get('requiresMoverAcceptance') === '1';
  const acceptanceReason = search.get('acceptanceReason');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async event => {
    event.preventDefault();
    if (password !== confirm) return setMessage({ severity: 'error', text: 'Passwords do not match.' });
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/set-password', { token, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userData', JSON.stringify(response.data.user));
      window.dispatchEvent(new Event('movd-auth-changed'));
      navigate(returnTo, { replace: true });
    } catch (error) {
      setMessage({ severity: 'error', text: error.response?.data?.error || 'Unable to set up your account.' });
    } finally { setLoading(false); }
  };

  const reasonCopy = { interprovincial_route: 'Because this move crosses provincial borders, your mover will review the route, crew, and equipment before confirming it.', capacity_verification: 'Your mover will review the shipment details and vehicle capacity before confirming dispatch.', specialty_handling: 'Your mover will review the specialty handling requirements and confirm the right equipment.' };

  return (
    <MovdAuthCard title="Set up your MOVD account" subtitle="Your payment was received. Create a password to access your customer portal and move updates.">
      <div style={{ display: 'grid', gap: 16 }}>
        {requiresMoverAcceptance && <MovdNotice tone="info">{reasonCopy[acceptanceReason] || 'Your mover will review the move details before confirming it.'}</MovdNotice>}
        {message && <MovdNotice tone={message.severity}>{message.text}</MovdNotice>}
        <form onSubmit={submit} style={{ display: 'grid', gap: 16 }}>
          <MovdInput label="New password" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="new-password" />
          <MovdInput label="Confirm password" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required autoComplete="new-password" />
          <MovdButton type="submit" disabled={loading || !token} loading={loading} style={{ width: '100%' }}>Set password and view booking</MovdButton>
        </form>
      </div>
    </MovdAuthCard>
  );
}
